(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-information"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function linkFeaturedMedia() {
      document.querySelectorAll('featured-product-information[data-product-url]').forEach(function (root) {
        var url = root.getAttribute('data-product-url');
        if (!url) return;
        root.querySelectorAll('.product-media').forEach(function (media) {
          if (media.querySelector(':scope > .featured-product-media-link')) return;
          var link = document.createElement('a');
          link.href = url;
          link.className = 'featured-product-media-link';
          link.setAttribute('aria-label', root.getAttribute('data-product-title') || '');
          media.appendChild(link);
        });
      });
    }

    function addShippingMessage() {
      document.querySelectorAll('featured-product-information[data-shipping-message]').forEach(function (root) {
        var msg = root.getAttribute('data-shipping-message');
        if (!msg) return;
        var price = root.querySelector('product-price');
        if (!price || price.querySelector('.featured-shipping-message')) return;
        var note = document.createElement('div');
        note.className = 'tax-note featured-shipping-message';
        note.textContent = msg;
        price.appendChild(note);
      });
    }

    function init() {
      linkFeaturedMedia();
      addShippingMessage();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var DESKTOP_MIN = 750;

    function init() {
      var header = document.querySelector('#header-component');
      if (!header || header.dataset.navWrapBound === 'true') return;
      // Only relevant when the inline menu style is in use; the drawer style is
      // already a hamburger at every width.
      if (header.getAttribute('data-menu-style') !== 'menu') return;

      var menu = header.querySelector('.header-menu');
      var columns = menu ? menu.closest('.header__columns') : null;
      if (!columns || !menu) return;

      header.dataset.navWrapBound = 'true';

      var scheduled = false;

      // Count how many rows the top-level menu items currently occupy by
      // collecting their distinct top positions.
      function rowCount() {
        var items = menu.querySelectorAll('.menu-list__list > .menu-list__list-item');
        var tops = [];
        for (var i = 0; i < items.length; i++) {
          if (!items[i].getClientRects().length) continue;
          var top = Math.round(items[i].getBoundingClientRect().top);
          var seen = false;
          for (var j = 0; j < tops.length; j++) {
            if (Math.abs(tops[j] - top) <= 2) { seen = true; break; }
          }
          if (!seen) tops.push(top);
        }
        return tops.length;
      }

      function isTouch() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      }

      function measure() {
        scheduled = false;

        // On touch devices the theme already decides menu vs drawer — don't interfere.
        if (isTouch()) return;

        if (window.innerWidth < DESKTOP_MIN) {
          // Below the desktop breakpoint the theme's own mobile layout owns the header.
          header.removeAttribute('data-nav-wrapped');
          return;
        }

        // Reset to the desktop single-line state to measure. All reads/writes happen
        // in this frame, so intermediate states are never painted (no flicker).
        header.removeAttribute('data-nav-wrapped');
        header.dataset.menuStyle = 'menu';

        // 1) Fits on a single line — leave it inline.
        if (columns.scrollWidth <= columns.clientWidth + 1) return;

        // 2) Overflows — wrap to a second line and see how tall it gets.
        header.setAttribute('data-nav-wrapped', 'true');

        // 3) If a single extra line isn't enough (3+ rows), switch to the theme's
        //    real mobile drawer layout instead of stacking more rows.
        if (rowCount() > 2) {
          header.removeAttribute('data-nav-wrapped');
          header.dataset.menuStyle = 'drawer';
        }
      }

      function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(measure);
      }

      if ('ResizeObserver' in window) {
        new ResizeObserver(schedule).observe(columns);
      }
      window.addEventListener('resize', schedule);

      // Web-font swaps change label widths after first paint; re-measure then.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(schedule).catch(function () {});
      }

      measure();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
